module.exports = __webpack_public_path__ + "img/Slider-3.8fd02615.jpg";